import {
  BarChartCard,
  BasicBarChartWithLabelCard,
  MultipleBarChartCard,
  StackBarChartCard,
} from "app/Components/ChartCard/ChartCard";
import { WidgetCard } from "app/Components/EhsDashboard/Global/Widgets";
import PieChartWithModal from "app/Components/PieChartWithModal/PieChartWithModal";
import {
  IS_USER_SITE_HO,
  IS_USER_SITE_MINES,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import { GlobalDashboardService } from "app/_services/GlobalDashboardService/GlobalDashboardService";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  barChartDataFormat,
  BasicBarChartWithLabelDataFormat,
  BasicBarChartWithLabelMonthDataFormat,
  pieChartDataWithModal,
  stackChartDataFormat,
} from "../Comman/config";
import DashboardNav from "../Comman/DashboardNav";
import RightFilter from "../RightFilter";
import { barChartListPageOne, WigetList, barPieChartListPageTwo } from "./Constant";
import { useSelector } from "react-redux";
import { getAllSites, getAllSitesWithAccess } from "app/_services/ehs/ehsSiteServices";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
const MedicalDashboard = () => {
  const [page, setPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [chart, setChart] = useState({});
  const [widgetData, setWidgetData] = useState(WigetList);
  const [allSite, setAllSite] = useState([]);
  const [haveAccessToSite, setHaveAccessToSite] = useState([]);
  const [currentSelectedSite, setCurrentSelectedSite] = useState({});
  const [loading, setLoading] = useState(true);
  const filterClick = (value) => {
    setShowFilter(value);
  };
  const pageValueFun = (value) => {
    setPage(value);
  };
  const globalSelectedSiteId = useSelector((state) => state.userData?.siteIds);
  useEffect(() => {
    getAllSitesWithAccess().then((res) => {
      setAllSite(res?.data?.availableSites);
    });
  }, []);

  useEffect(() => {
    const getSiteData = allSite?.find((d) => d.id == globalSelectedSiteId);
    setCurrentSelectedSite(getSiteData);
    // pageValueFun(getSiteData?.siteType == 3 ? 2 : 1);
    const haveAccessToSiteArray =
      getSiteData?.siteType == 1
        ? allSite?.map((d) => {
            return d.id;
          })
        : getSiteData?.siteType == 2
        ? allSite
            ?.filter((d) => {
              if (d.id == globalSelectedSiteId || d.parentSiteId == globalSelectedSiteId)
                return d.id;
            })
            .map((d) => {
              return d.id;
            })
        : getSiteData?.siteType == 3
        ? allSite
            ?.filter((d) => {
              if (d.id == globalSelectedSiteId) return d.id;
            })
            .map((d) => {
              return d.id;
            })
        : [];

    setHaveAccessToSite(haveAccessToSiteArray);
  }, [allSite, globalSelectedSiteId]);

  const dashboardData = useCallback(
    async (filter) => {
      let obj = {
        startDate: filter?.startDate,
        endDate: filter?.endDate,
        siteId: filter?.siteId
          ? filter?.siteId
          : globalSelectedSiteId
          ? haveAccessToSite
          : null,
      };
      if (
        JSON.stringify(obj) === JSON.stringify({ siteId: [] }) ||
        JSON.stringify(obj) === JSON.stringify({ siteId: null })
      ) {
        return;
      }
      let response = await GlobalDashboardService.medicalDashboard(obj);

      if (response && response.status && response.data) {
        const dashboardData = response.data;

        const barChartObjPageOne = {};
        barChartListPageOne.map((d) => {
          barChartObjPageOne[d.value] =
            d.type === "stack"
              ? stackChartDataFormat(dashboardData?.[d.value])
              : barChartDataFormat(dashboardData?.[d.value]);
        });

        const barPieChartObjPageTwo = {};
        barPieChartListPageTwo.map((d) => {
          barPieChartObjPageTwo[d.value] =
            d.type === "bar"
              ? barChartDataFormat(dashboardData?.[d.value])
              : d.type === "stack"
              ? barChartDataFormat(dashboardData?.[d.value])
              : d.type === "barWithLabel"
              ? BasicBarChartWithLabelDataFormat(dashboardData?.[d.value])
              : d.type === "barWithLabelMonth"
              ? BasicBarChartWithLabelMonthDataFormat(dashboardData?.[d.value])
              : pieChartDataWithModal(dashboardData?.[d.value]);
        });

        setChart(() => ({
          ...barChartObjPageOne,
          ...barPieChartObjPageTwo,
        }));

        setWidgetData((prev) => {
          return prev.map((d) => ({
            ...d,
            value: dashboardData?.[d.key],
          }));
        });
      }
      setLoading(false);
    },
    [globalSelectedSiteId, haveAccessToSite]
  );

  useEffect(() => {
    dashboardData();
  }, [dashboardData]);

  const applyFilter = (filter) => {
    dashboardData(filter);
  };

  return (
    <>
      <Row>
        <Col lg={showFilter ? 9 : 12}>
          <Row>
            <Col lg={12}>
              <DashboardNav
                screenCount={
                  (globalSelectedSiteId && currentSelectedSite?.siteType == 3
                    ? true
                    : false) || IS_USER_SITE_MINES()
                    ? 1
                    : 2
                }
                pageBool={pageValueFun}
                onFilterBool={filterClick}
                page={page}
                dashboardName="Health Management"
                id={"screen_" + page}
              />
            </Col>
          </Row>
          {!loading ? (
            <>
              {" "}
              {!IS_USER_SITE_MINES() &&
                (globalSelectedSiteId ? currentSelectedSite?.siteType != 3 : true) &&
                page == 1 && (
                  <div className="screenOne" id={"screen_" + page}>
                    <Row>
                      {barChartListPageOne?.map((item, idx) => (
                        <Col
                          lg={item?.isMines ? 12 : 6}
                          id={"main_" + idx}
                          key={idx}
                          className="mb-4 pb-2"
                        >
                          {IS_USER_SITE_HO() ? (
                            item?.type === "bar" ? (
                              <MultipleBarChartCard
                                title={item?.name}
                                id={"main_" + idx}
                                yAxisName={item?.yAxisName}
                                xAxisName={item?.xAxisName}
                                category={chart[item?.value]?.categoryData}
                                seriesData={chart[item?.value]?.data}
                              />
                            ) : item.type === "stack" ? (
                              <StackBarChartCard
                                title={item?.name}
                                id={"main_" + idx}
                                yAxisName={item?.yAxisName}
                                xAxisName={item?.xAxisName}
                                categoryData={chart[item?.value]?.categoryData}
                                seriesData={chart[item?.value]?.data}
                              />
                            ) : (
                              <PieChartWithModal
                                title={item.title}
                                id={"main_" + idx}
                                seriesData={chart[item?.value] || []}
                                customLabelFalse={true}
                                isCustomLegend={true}
                              />
                            )
                          ) : !item?.isHo && !IS_USER_SITE_HO() ? (
                            item?.type === "bar" ? (
                              <MultipleBarChartCard
                                title={item?.name}
                                id={"main_" + idx}
                                yAxisName={item?.yAxisName}
                                xAxisName={item?.xAxisName}
                                category={chart[item?.value]?.categoryData}
                                seriesData={chart[item?.value]?.data}
                              />
                            ) : item.type === "stack" ? (
                              <StackBarChartCard
                                title={item?.name}
                                id={"main_" + idx}
                                yAxisName={item?.yAxisName}
                                xAxisName={item?.xAxisName}
                                categoryData={chart[item?.value]?.categoryData}
                                seriesData={chart[item?.value]?.data}
                              />
                            ) : (
                              <PieChartWithModal
                                title={item.title}
                                id={"main_" + idx}
                                seriesData={chart[item?.value] || []}
                                customLabelFalse={true}
                                isCustomLegend={true}
                              />
                            )
                          ) : (
                            ""
                          )}
                        </Col>
                      ))}
                    </Row>
                  </div>
                )}
              {(((IS_USER_SITE_MINES() ||
                (globalSelectedSiteId && currentSelectedSite?.siteType == 3
                  ? true
                  : false)) &&
                page == 1) ||
                page == 2) && (
                <Row className="screentwo m-0" id={"screen_" + page}>
                  <Col lg={12} className="widgetContainer mt-3 p-0">
                    <WidgetCard isFilterClick={showFilter} widgetData={widgetData} />
                  </Col>

                  <Row>
                    {barPieChartListPageTwo?.map((item, idx) => (
                      <Col
                        lg={item?.isMines ? 12 : 6}
                        id={"main_" + idx}
                        key={idx}
                        className="mb-4 pb-2"
                      >
                        {item.type === "bar" ? (
                          <MultipleBarChartCard
                            title={item?.name}
                            id={"main_" + idx}
                            yAxisName={item?.yAxisName}
                            xAxisName={item?.xAxisName}
                            category={chart[item?.value]?.categoryData}
                            seriesData={chart[item?.value]?.data}
                          />
                        ) : item.type === "barWithLabel" ? (
                          <BasicBarChartWithLabelCard
                            title={item?.name}
                            id={"main_" + idx}
                            yAxisName={item?.yAxisName}
                            xAxisName={item?.xAxisName}
                            category={chart[item?.value]?.categoryData}
                            seriesData={chart[item?.value]?.data}
                          />
                        ) : item.type === "barWithLabelMonth" ? (
                          <BasicBarChartWithLabelCard
                            title={item?.name}
                            id={"main_" + idx}
                            yAxisName={item?.yAxisName}
                            xAxisName={item?.xAxisName}
                            // category={chart[item?.value]?.categoryData}
                            seriesData={chart[item?.value]?.data}
                          />
                        ) : (
                          <PieChartWithModal
                            title={item.title}
                            id={"main_" + idx}
                            seriesData={chart[item?.value] || []}
                            customLabelFalse={true}
                            isCustomLegend={true}
                          />
                        )}
                      </Col>
                    ))}
                  </Row>
                </Row>
              )}
            </>
          ) : (
            <NetZeroLoader addZIndex={true} />
          )}
        </Col>

        <Col lg={2} className={`d-${showFilter ? "block" : "none"}`}>
          <RightFilter applyFilter={applyFilter} />
        </Col>
      </Row>
    </>
  );
};

export default MedicalDashboard;
